export * from './main';
export * from './constants';

import { List } from 'immutable';
import {
  PLAIN,
  ORDERED_LIST,
  UNORDERED_LIST,
  POEM,
  EXPRESSIONS,
  TIP,
} from './constants';

export const PARAGRAPH_STYLES = List([
  PLAIN,
  ORDERED_LIST,
  UNORDERED_LIST,
  POEM,
  EXPRESSIONS,
  TIP,
]);
